import React from "react";
import PropTypes from "prop-types";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts";

import { classNames } from "primereact/utils";

function CustomizedAxisTick({ x, y, payload }) {
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} textAnchor="middle" fill="#666">
        {Math.abs(payload.value)}
      </text>
    </g>
  );
}

export default function ModuleChartBarDiverging({
  className = "",
  styles = {},
  data = {
    keys: {
      left: {
        key: "left",
        label: "",
        bgColor: "",
      },
      right: {
        key: "right",
        label: "",
        bgColor: "",
      },
    },
    data: [],
  },
  options = {},
}) {
  const {
    layout = "vertical",
    dataKey = "label",
    xyLabelColor = "#a3a3a3",
    margin = {
      top: 20,
      right: 80,
      left: 80,
      bottom: 10,
    },
    barSize = 15,
    isTooltip = true,
    isLegend = true,
  } = options;

  const formatData = data.data.map((item) => ({
    ...item,
    [data.keys.left.key]: -item[data.keys.left.key],
  }));

  return (
    <div className={classNames("inline-block", className)} style={styles}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          layout={layout}
          data={formatData}
          margin={margin}
          barSize={barSize}
          barGap={-barSize}
        >
          <XAxis
            type="number"
            stroke={xyLabelColor}
            tick={<CustomizedAxisTick />}
          />
          <YAxis
            yAxisId="left"
            dataKey={dataKey}
            type="category"
            stroke={xyLabelColor}
          />

          <Bar
            yAxisId="left"
            dataKey={data.keys.left.key}
            name={data.keys.left.name ?? data.keys.left.key}
            fill={data.keys.left.bgColor ?? "#8797a5"}
          />
          <Bar
            yAxisId="left"
            dataKey={data.keys.right.key}
            name={data.keys.right.name ?? data.keys.right.key}
            fill={data.keys.right.bgColor ?? "#13A8A8"}
          />

          {isTooltip && (
            <Tooltip
              cursor={{ fill: "#ffffff00" }}
              formatter={(v) => Math.abs(v)}
            />
          )}
          {isLegend && <Legend />}

          {data.referenceKey?.map((item) => (
              <ReferenceLine
                key={`refer_${item.yAxisId ?? "left"}-${item.value}-${item.label ?? ""}`}
                yAxisId={item.yAxisId ?? "left"}
                x={item.value}
                label={item.label ?? ""}
                stroke={item.color ?? xyLabelColor}
              />
            ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

const divergingKeyShape = PropTypes.shape({
  key: PropTypes.string,
  name: PropTypes.string,
  bgColor: PropTypes.string,
});

CustomizedAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  payload: PropTypes.shape({
    value: PropTypes.number,
  }),
};

ModuleChartBarDiverging.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.object,
  data: PropTypes.shape({
    keys: PropTypes.shape({
      left: divergingKeyShape,
      right: divergingKeyShape,
    }),
    data: PropTypes.arrayOf(PropTypes.object),
    referenceKey: PropTypes.arrayOf(
      PropTypes.shape({
        yAxisId: PropTypes.string,
        value: PropTypes.number,
        label: PropTypes.string,
        color: PropTypes.string,
      }),
    ),
  }),
  options: PropTypes.shape({
    layout: PropTypes.string,
    dataKey: PropTypes.string,
    xyLabelColor: PropTypes.string,
    margin: PropTypes.object,
    barSize: PropTypes.number,
    isTooltip: PropTypes.bool,
    isLegend: PropTypes.bool,
  }),
};
